import type { LayoutType, MenuBoardConfig, MenuBoardLayout, MenuInput, Section } from "../types.js";

export function canAddHeroSection(sections: Section[]): boolean {
  return !sections.some((s) => s.type === "hero" || s.type === "combo-highlight");
}

export function countScreenItems(sections: Section[]): number {
  let count = 0;
  for (const section of sections) {
    count += section.items.length;
  }
  return count;
}

export function isScreenFull(sections: Section[], maxItems: number): boolean {
  return countScreenItems(sections) >= maxItems;
}

export function chooseLayoutType(input: MenuInput, config: MenuBoardConfig): LayoutType {
  if (config.preferredLayout) return config.preferredLayout;

  const totalItems = input.products.length + (input.combos?.length ?? 0);
  const hasCombos = (input.combos?.length ?? 0) > 0;

  if (hasCombos && totalItems <= 16) return "hero-grid";
  if (input.categories.length >= 3 && input.products.length > 16) return "category-based";
  return "grid-only";
}

export function validateLayout(layout: MenuBoardLayout): string[] {
  const errors: string[] = [];
  const allIds = new Set<string>();

  for (const screen of layout.screens) {
    let heroCount = 0;

    for (const section of screen.sections) {
      if (section.type === "hero" || section.type === "combo-highlight") {
        heroCount++;
      }
      for (const item of section.items) {
        if (allIds.has(item.id)) {
          errors.push(`Duplicate item id "${item.id}" in layout`);
        }
        allIds.add(item.id);
      }
    }

    if (heroCount > 1) {
      errors.push(
        `Screen ${String(screen.index)} has ${String(heroCount)} hero/highlight sections (max 1)`,
      );
    }
  }

  return errors;
}
